export default {
    'Regular': {
        fontFamily: '"MarinexWebFont"',
        fontWeight: 400,
        fontStyle: 'normal',
    },
    'Bold': {
        fontFamily: 'MarinexWebFont',
        fontWeight: 700,
        fontStyle: 'normal',
    },
    'Condensed': {
        fontFamily: 'MarinexWebFontCondensed',
        fontWeight: 400,
        fontStyle: 'normal'
    },
};


// WEBPACK FOOTER //
// ./src/constants/fonts.ts